import React from 'react';
import { TextField, Box } from '@mui/material';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateAdapter from '@mui/lab/AdapterDateFns'; // 사용하는 어댑터에 맞게 수정
import koLocale from 'date-fns/locale/ko';
import DatePicker from '@mui/lab/DatePicker';
const CommonDatePicker = ({ 
  label, 
  name, 
  value, 
  onChange, 
  formik, 
  width = '130px' // 기본 너비 설정
}) => {
  return (
    <Box sx={{ width: width, display: 'inline-block', mx: 2 }}>
      <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
        <DatePicker
          label={label}
          inputFormat="yyyy-MM-dd"
          mask="____-__-__"
          value={value}
          onChange={(newValue) => {
            // Formik 상태와 로컬 상태를 동시에 업데이트할 수 있도록 지원
            onChange(newValue, name);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              id={name}
              name={name}
              variant="standard"
              fullWidth
              error={formik.touched[name] && Boolean(formik.errors[name])}
              helperText={formik.touched[name] && formik.errors[name]}
              // 텍스트 필드 사이즈 미세 조절
              
            />
          )}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default CommonDatePicker;
